import { render, staticRenderFns } from "./board-input.vue?vue&type=template&id=5723ac64&"
import script from "./board-input.vue?vue&type=script&lang=js&"
export * from "./board-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports